<div class="fleet-overview-audit">
  <div *ngIf="tailsLoading">Loading...</div>

  <ng-container *ngIf="!tailsLoading">
    <mat-accordion *ngIf="tails.length; else noTails" displayMode="flat">
      <mat-expansion-panel
        *ngFor="let tail of tails; trackBy: tailTrackByFn"
        (opened)="selectTail(tail)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>{{ tail.number }}</mat-panel-title>
          <mat-panel-description [ngClass]="{ 'text-muted': !tail.active }">
            {{ tail.active ? 'Active' : 'Inactive' }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div *ngIf="selectedTail?.id === tail.id" class="fleet-audit-logs">
            <div *ngIf="logsLoading">Loading...</div>

            <ng-container *ngIf="!logsLoading">
              <div *ngIf="logs.length; else noLogs">
                <div class="fleet-audit-log" *ngFor="let log of logs; trackBy: logTrackByFn">
                  <div class="fleet-audit-log-header">
                    <strong>{{ log.action }}</strong>
                    <span>by {{ log.performedBy }} on {{ log.time | date : 'short' }}</span>
                  </div>
                  <div *ngIf="log.fields?.length" class="fleet-audit-log-fields">
                    <div class="fleet-audit-log-field" *ngFor="let field of log.fields">
                      <span class="field-name">{{ field.name }}</span>
                      <span>{{ field.oldValue }}</span>
                      <span>&rarr;</span>
                      <span>{{ field.newValue }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noLogs>
                <em class="text-warning">No audit logs were found for this tail</em>
              </ng-template>
            </ng-container>

            <sd-pagination
              *ngIf="logs.length"
              [dataSubscription]="logsPagination$"
              (paginationEvent)="onLogsPageChange($event)"
            ></sd-pagination>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noTails>
      <div class="text-center">
        <em class="text-warning">No tails were found</em>
      </div>
    </ng-template>
  </ng-container>

  <footer>
    <sd-pagination
      *ngIf="tails.length"
      [dataSubscription]="tailsPagination$"
      (paginationEvent)="onTailsPageChange($event)"
    ></sd-pagination>
  </footer>
</div>
